import { Typography, Box } from "@mui/material";
import { palette } from "../../theme";

export const TypingIndicator = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "8px 16px",
      width: "fit-content",
      height: "32px",
      borderRadius: "16px",
      backgroundColor: palette.purple_light,
      animation: "fadeIn 0.3s ease-out",
      "@keyframes fadeIn": {
        "0%": {
          opacity: 0,
          transform: "translateY(10px)",
        },
        "100%": {
          opacity: 1,
          transform: "translateY(0)",
        },
      },
    }}
  >
    <Typography
      variant="body2"
      color={palette.purple_dark}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "24px",
        gap: "4px",
        "@keyframes bounce": {
          "0%, 100%": {
            transform: "translateY(0)",
          },
          "50%": {
            transform: "translateY(-4px)",
          },
        },
      }}
    >
      <span
        style={{
          animation: "bounce 1s infinite 0s",
        }}
      >
        .
      </span>
      <span
        style={{
          animation: "bounce 1s infinite 0.2s",
        }}
      >
        .
      </span>
      <span
        style={{
          animation: "bounce 1s infinite 0.4s",
        }}
      >
        .
      </span>
    </Typography>
  </Box>
);
